import axios from "axios";

// Utils
import { warn } from "./logger";
import { isLocal, isProd } from "./env";

const InternalApi = axios.create({
  baseURL: isLocal
    ? `http://localhost:8000/api/v1`
    : isProd
    ? `https://prefportal.mbdt01.com/api/v1`
    : `https://prefportal.t.mbdt01.com/api/v1`,
});

export default InternalApi;

// Add authorization token to API calls
export const setInternalAuthHeader = (token?: string) => {
  if (token) {
    warn(`[+] Adding Authorization token to Internal API calls`);
    InternalApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    warn(`[-] Removing Authorization token from API calls`);
    delete InternalApi.defaults.headers.common["Authorization"];
  }
};
